export const CreditCardUpIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    className={className}
  >
    <path
      d="M13.3334 12L15.8334 9.49996M15.8334 9.49996L18.3334 12M15.8334 9.49996V14.5M18.3334 5.33329H1.66669M18.3334 6.99996V3.83329C18.3334 2.89987 18.3334 2.43316 18.1517 2.07664C17.9919 1.76304 17.7369 1.50807 17.4233 1.34828C17.0668 1.16663 16.6001 1.16663 15.6667 1.16663H4.33335C3.39993 1.16663 2.93322 1.16663 2.5767 1.34828C2.2631 1.50807 2.00813 1.76304 1.84834 2.07664C1.66669 2.43316 1.66669 2.89987 1.66669 3.83329V10.1666C1.66669 11.1 1.66669 11.5668 1.84834 11.9233C2.00813 12.2369 2.2631 12.4918 2.5767 12.6516C2.93322 12.8333 3.39993 12.8333 4.33335 12.8333H10"
      stroke="#0C111D"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
